import type { IconDefinition } from '../index.tsx';

export const iconMinus: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconMinus',
  icon: [16, 16, [], '', 'M1 6V10L15 10V6L1 6Z'],
};
